import { Component, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { hasValidator } from '../_helpers/functions';

@Component({
    selector: 'sume-textarea',
    templateUrl: './textarea.component.html',
})
export class TextAreaComponent implements OnInit {
    @Input() label: string;
    @Input() controlName: string;
    @Input() formGroup: FormGroup;
    @Input() messages: any;
    @Input() changeText = false;
    @Input() shape = { rows: 5, cols: 60 };
    @Output() current: any;
    isRequired: boolean;

    get formControl(): AbstractControl {
        return this.formGroup.get(this.controlName);
    }

    ngOnInit(): void {
        this.isRequired = hasValidator(
            this.formGroup.controls[this.controlName],
            'required'
        );
    }
}
